import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from "@reduxjs/toolkit/query";
import AuthService from "../authService";
import { runTimeConfig } from "@/config";

// Base URL from environment
const baseUrl = runTimeConfig.VITE_BASE_URL;

// Token from environment
const authService = new AuthService();

// const token: string = authService.getToken();
// console.log("Token", token);

// Base query with token and headers
const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");
    return headers;
  }
});

// Wrapper for custom error handling
const baseQueryWithErrorHandling: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  unknown,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  try {
    const result = await rawBaseQuery(args, api, extraOptions as any);
    if (result.error) {
      const status = result.error.status;

      // Log error
      console.error("API Error:", result.error);

      // Handle specific errors
      if (status === 401) {
        authService.signoutRedirectCallback();
      }

      if (status === "FETCH_ERROR") {
        return {
          error: {
            status: "CUSTOM_ERROR",
            data: "Unable to reach the server. Please check your internet connection."
          } as FetchBaseQueryError
        };
      }
    }

    return result;
  } catch (error: any) {
    console.error("Unexpected Error:", error);
    return {
      error: {
        status: error?.status || 500,
        data: error?.data || error?.message || "Unknown error"
      } as FetchBaseQueryError
    };
  }
};

// RTK Query API Setup
export const ticketApi = createApi({
  reducerPath: "ticketApi",
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ["ProjectBoards", "userStories"],
  endpoints: () => ({})
});
